import axios from 'axios';
import { configRefs } from '@utils/config';

async function getEkeyUserData(userId) {
  var _a;
  const response = await axios.get(
    `${(_a = await configRefs.apis.gas.get()) == null ? void 0 : _a.replaceAll(
      "{{version}}",
      "v"
    )}/api/User/GetEkeyUserDetailsByEmail?userEmail=${encodeURIComponent(
      userId
    )}`
  );
  return {
    id: userId,
    name: `${response.data.FirstName} ${response.data.LastName}`,
    role: "teacher",
    authenticationProvider: "ekey"
  };
}

export { getEkeyUserData };
//# sourceMappingURL=request.get-user-identity.e-key.js.map
